import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icon.css'
import axios from 'axios'
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.prototype.$ = $
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach(function (to, from, next) {
  if (to.name == "personal") {
    ElementUI.Message.info("线上缴费功能开发中，敬请期待！")
    return
  } else {
    next()
  }
});